/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base';
// @ts-ignore
import { LocationsIdpackageDealsGetCollection200Response } from '../model';
// @ts-ignore
import { PackageDealOrderPackagedealChangeOrder } from '../model';
// @ts-ignore
import { PackageDealRead } from '../model';
// @ts-ignore
import { PackageDealWrite } from '../model';
// @ts-ignore
import { PackageDealsGetCollection200Response } from '../model';
/**
 * PackageDealApi - axios parameter creator
 * @export
 */
export const PackageDealApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of PackageDeal resources.
     * @summary Get base package deal for given location
     * @param {number} id Location for retrieving base packagedeal for
     * @param {string} startTime Start time of hall to determine base packagedeal for
     * @param {string} endTime End date of hall to determine base packagedeal for
     * @param {string} date Date to filter available package deal
     * @param {number} pax Pax of hall to determine base packagedeal for
     * @param {string} [email] E-mail address for the reservation used to determine if the request falls under a contract
     * @param {LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum} [orderTranslationsName]
     * @param {LocationsIdpackageDealsGetCollectionOrderTypeEnum} [orderType]
     * @param {LocationsIdpackageDealsGetCollectionOrderLocationNameEnum} [orderLocationName]
     * @param {LocationsIdpackageDealsGetCollectionOrderPriceEnum} [orderPrice]
     * @param {LocationsIdpackageDealsGetCollectionOrderAvailableEnum} [orderAvailable]
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [type]
     * @param {Array<string>} [type2]
     * @param {string} [timeslots]
     * @param {Array<string>} [timeslots2]
     * @param {string} [period]
     * @param {Array<string>} [period2]
     * @param {string} [translationsName]
     * @param {boolean} [cateringPackage]
     * @param {boolean} [includingHallRental]
     * @param {boolean} [available]
     * @param {boolean} [deleted]
     * @param {string} [reservation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsIdpackageDealsGetCollection: async (
      id: number,
      startTime: string,
      endTime: string,
      date: string,
      pax: number,
      email?: string,
      orderTranslationsName?: LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum,
      orderType?: LocationsIdpackageDealsGetCollectionOrderTypeEnum,
      orderLocationName?: LocationsIdpackageDealsGetCollectionOrderLocationNameEnum,
      orderPrice?: LocationsIdpackageDealsGetCollectionOrderPriceEnum,
      orderAvailable?: LocationsIdpackageDealsGetCollectionOrderAvailableEnum,
      location?: string,
      location2?: Array<string>,
      type?: string,
      type2?: Array<string>,
      timeslots?: string,
      timeslots2?: Array<string>,
      period?: string,
      period2?: Array<string>,
      translationsName?: string,
      cateringPackage?: boolean,
      includingHallRental?: boolean,
      available?: boolean,
      deleted?: boolean,
      reservation?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('locationsIdpackageDealsGetCollection', 'id', id);
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists(
        'locationsIdpackageDealsGetCollection',
        'startTime',
        startTime,
      );
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists(
        'locationsIdpackageDealsGetCollection',
        'endTime',
        endTime,
      );
      // verify required parameter 'date' is not null or undefined
      assertParamExists('locationsIdpackageDealsGetCollection', 'date', date);
      // verify required parameter 'pax' is not null or undefined
      assertParamExists('locationsIdpackageDealsGetCollection', 'pax', pax);
      const localVarPath = `/api/locations/{id}/package_deals`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (startTime !== undefined) {
        localVarQueryParameter['startTime'] = startTime;
      }

      if (endTime !== undefined) {
        localVarQueryParameter['endTime'] = endTime;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      if (pax !== undefined) {
        localVarQueryParameter['pax'] = pax;
      }

      if (email !== undefined) {
        localVarQueryParameter['email'] = email;
      }

      if (orderTranslationsName !== undefined) {
        localVarQueryParameter['order[translations.name]'] =
          orderTranslationsName;
      }

      if (orderType !== undefined) {
        localVarQueryParameter['order[type]'] = orderType;
      }

      if (orderLocationName !== undefined) {
        localVarQueryParameter['order[location.name]'] = orderLocationName;
      }

      if (orderPrice !== undefined) {
        localVarQueryParameter['order[price]'] = orderPrice;
      }

      if (orderAvailable !== undefined) {
        localVarQueryParameter['order[available]'] = orderAvailable;
      }

      if (location !== undefined) {
        localVarQueryParameter['location'] = location;
      }

      if (location2) {
        localVarQueryParameter['location[]'] = location2;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (type2) {
        localVarQueryParameter['type[]'] = type2;
      }

      if (timeslots !== undefined) {
        localVarQueryParameter['timeslots'] = timeslots;
      }

      if (timeslots2) {
        localVarQueryParameter['timeslots[]'] = timeslots2;
      }

      if (period !== undefined) {
        localVarQueryParameter['period'] = period;
      }

      if (period2) {
        localVarQueryParameter['period[]'] = period2;
      }

      if (translationsName !== undefined) {
        localVarQueryParameter['translations.name'] = translationsName;
      }

      if (cateringPackage !== undefined) {
        localVarQueryParameter['cateringPackage'] = cateringPackage;
      }

      if (includingHallRental !== undefined) {
        localVarQueryParameter['includingHallRental'] = includingHallRental;
      }

      if (available !== undefined) {
        localVarQueryParameter['available'] = available;
      }

      if (deleted !== undefined) {
        localVarQueryParameter['deleted'] = deleted;
      }

      if (reservation !== undefined) {
        localVarQueryParameter['reservation'] = reservation;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of PackageDeal resources.
     * @summary Retrieves the collection of PackageDeal resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {PackageDealsGetCollectionOrderTranslationsNameEnum} [orderTranslationsName]
     * @param {PackageDealsGetCollectionOrderTypeEnum} [orderType]
     * @param {PackageDealsGetCollectionOrderLocationNameEnum} [orderLocationName]
     * @param {PackageDealsGetCollectionOrderPriceEnum} [orderPrice]
     * @param {PackageDealsGetCollectionOrderAvailableEnum} [orderAvailable]
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [type]
     * @param {Array<string>} [type2]
     * @param {string} [timeslots]
     * @param {Array<string>} [timeslots2]
     * @param {string} [period]
     * @param {Array<string>} [period2]
     * @param {string} [translationsName]
     * @param {boolean} [cateringPackage]
     * @param {boolean} [includingHallRental]
     * @param {boolean} [available]
     * @param {boolean} [deleted]
     * @param {string} [reservation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealsGetCollection: async (
      page?: number,
      itemsPerPage?: number,
      orderTranslationsName?: PackageDealsGetCollectionOrderTranslationsNameEnum,
      orderType?: PackageDealsGetCollectionOrderTypeEnum,
      orderLocationName?: PackageDealsGetCollectionOrderLocationNameEnum,
      orderPrice?: PackageDealsGetCollectionOrderPriceEnum,
      orderAvailable?: PackageDealsGetCollectionOrderAvailableEnum,
      location?: string,
      location2?: Array<string>,
      type?: string,
      type2?: Array<string>,
      timeslots?: string,
      timeslots2?: Array<string>,
      period?: string,
      period2?: Array<string>,
      translationsName?: string,
      cateringPackage?: boolean,
      includingHallRental?: boolean,
      available?: boolean,
      deleted?: boolean,
      reservation?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/package_deals`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter['itemsPerPage'] = itemsPerPage;
      }

      if (orderTranslationsName !== undefined) {
        localVarQueryParameter['order[translations.name]'] =
          orderTranslationsName;
      }

      if (orderType !== undefined) {
        localVarQueryParameter['order[type]'] = orderType;
      }

      if (orderLocationName !== undefined) {
        localVarQueryParameter['order[location.name]'] = orderLocationName;
      }

      if (orderPrice !== undefined) {
        localVarQueryParameter['order[price]'] = orderPrice;
      }

      if (orderAvailable !== undefined) {
        localVarQueryParameter['order[available]'] = orderAvailable;
      }

      if (location !== undefined) {
        localVarQueryParameter['location'] = location;
      }

      if (location2) {
        localVarQueryParameter['location[]'] = location2;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (type2) {
        localVarQueryParameter['type[]'] = type2;
      }

      if (timeslots !== undefined) {
        localVarQueryParameter['timeslots'] = timeslots;
      }

      if (timeslots2) {
        localVarQueryParameter['timeslots[]'] = timeslots2;
      }

      if (period !== undefined) {
        localVarQueryParameter['period'] = period;
      }

      if (period2) {
        localVarQueryParameter['period[]'] = period2;
      }

      if (translationsName !== undefined) {
        localVarQueryParameter['translations.name'] = translationsName;
      }

      if (cateringPackage !== undefined) {
        localVarQueryParameter['cateringPackage'] = cateringPackage;
      }

      if (includingHallRental !== undefined) {
        localVarQueryParameter['includingHallRental'] = includingHallRental;
      }

      if (available !== undefined) {
        localVarQueryParameter['available'] = available;
      }

      if (deleted !== undefined) {
        localVarQueryParameter['deleted'] = deleted;
      }

      if (reservation !== undefined) {
        localVarQueryParameter['reservation'] = reservation;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a PackageDeal resource.
     * @summary Retrieves a PackageDeal resource.
     * @param {string} id PackageDeal identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealsIdGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('packageDealsIdGet', 'id', id);
      const localVarPath = `/api/package_deals/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates the PackageDeal resource.
     * @summary Updates the PackageDeal resource.
     * @param {string} id PackageDeal identifier
     * @param {PackageDealWrite} packageDealWrite The updated PackageDeal resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealsIdPatch: async (
      id: string,
      packageDealWrite: PackageDealWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('packageDealsIdPatch', 'id', id);
      // verify required parameter 'packageDealWrite' is not null or undefined
      assertParamExists(
        'packageDealsIdPatch',
        'packageDealWrite',
        packageDealWrite,
      );
      const localVarPath = `/api/package_deals/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        packageDealWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a PackageDealOrder resource.
     * @summary Change the order of the package deal priority
     * @param {PackageDealOrderPackagedealChangeOrder} packageDealOrderPackagedealChangeOrder The new PackageDealOrder resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealschangeOrderPost: async (
      packageDealOrderPackagedealChangeOrder: PackageDealOrderPackagedealChangeOrder,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'packageDealOrderPackagedealChangeOrder' is not null or undefined
      assertParamExists(
        'packageDealschangeOrderPost',
        'packageDealOrderPackagedealChangeOrder',
        packageDealOrderPackagedealChangeOrder,
      );
      const localVarPath = `/api/package_deals/change_order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        packageDealOrderPackagedealChangeOrder,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PackageDealApi - functional programming interface
 * @export
 */
export const PackageDealApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    PackageDealApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of PackageDeal resources.
     * @summary Get base package deal for given location
     * @param {number} id Location for retrieving base packagedeal for
     * @param {string} startTime Start time of hall to determine base packagedeal for
     * @param {string} endTime End date of hall to determine base packagedeal for
     * @param {string} date Date to filter available package deal
     * @param {number} pax Pax of hall to determine base packagedeal for
     * @param {string} [email] E-mail address for the reservation used to determine if the request falls under a contract
     * @param {LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum} [orderTranslationsName]
     * @param {LocationsIdpackageDealsGetCollectionOrderTypeEnum} [orderType]
     * @param {LocationsIdpackageDealsGetCollectionOrderLocationNameEnum} [orderLocationName]
     * @param {LocationsIdpackageDealsGetCollectionOrderPriceEnum} [orderPrice]
     * @param {LocationsIdpackageDealsGetCollectionOrderAvailableEnum} [orderAvailable]
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [type]
     * @param {Array<string>} [type2]
     * @param {string} [timeslots]
     * @param {Array<string>} [timeslots2]
     * @param {string} [period]
     * @param {Array<string>} [period2]
     * @param {string} [translationsName]
     * @param {boolean} [cateringPackage]
     * @param {boolean} [includingHallRental]
     * @param {boolean} [available]
     * @param {boolean} [deleted]
     * @param {string} [reservation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async locationsIdpackageDealsGetCollection(
      id: number,
      startTime: string,
      endTime: string,
      date: string,
      pax: number,
      email?: string,
      orderTranslationsName?: LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum,
      orderType?: LocationsIdpackageDealsGetCollectionOrderTypeEnum,
      orderLocationName?: LocationsIdpackageDealsGetCollectionOrderLocationNameEnum,
      orderPrice?: LocationsIdpackageDealsGetCollectionOrderPriceEnum,
      orderAvailable?: LocationsIdpackageDealsGetCollectionOrderAvailableEnum,
      location?: string,
      location2?: Array<string>,
      type?: string,
      type2?: Array<string>,
      timeslots?: string,
      timeslots2?: Array<string>,
      period?: string,
      period2?: Array<string>,
      translationsName?: string,
      cateringPackage?: boolean,
      includingHallRental?: boolean,
      available?: boolean,
      deleted?: boolean,
      reservation?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LocationsIdpackageDealsGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.locationsIdpackageDealsGetCollection(
          id,
          startTime,
          endTime,
          date,
          pax,
          email,
          orderTranslationsName,
          orderType,
          orderLocationName,
          orderPrice,
          orderAvailable,
          location,
          location2,
          type,
          type2,
          timeslots,
          timeslots2,
          period,
          period2,
          translationsName,
          cateringPackage,
          includingHallRental,
          available,
          deleted,
          reservation,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'PackageDealApi.locationsIdpackageDealsGetCollection'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves the collection of PackageDeal resources.
     * @summary Retrieves the collection of PackageDeal resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {PackageDealsGetCollectionOrderTranslationsNameEnum} [orderTranslationsName]
     * @param {PackageDealsGetCollectionOrderTypeEnum} [orderType]
     * @param {PackageDealsGetCollectionOrderLocationNameEnum} [orderLocationName]
     * @param {PackageDealsGetCollectionOrderPriceEnum} [orderPrice]
     * @param {PackageDealsGetCollectionOrderAvailableEnum} [orderAvailable]
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [type]
     * @param {Array<string>} [type2]
     * @param {string} [timeslots]
     * @param {Array<string>} [timeslots2]
     * @param {string} [period]
     * @param {Array<string>} [period2]
     * @param {string} [translationsName]
     * @param {boolean} [cateringPackage]
     * @param {boolean} [includingHallRental]
     * @param {boolean} [available]
     * @param {boolean} [deleted]
     * @param {string} [reservation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packageDealsGetCollection(
      page?: number,
      itemsPerPage?: number,
      orderTranslationsName?: PackageDealsGetCollectionOrderTranslationsNameEnum,
      orderType?: PackageDealsGetCollectionOrderTypeEnum,
      orderLocationName?: PackageDealsGetCollectionOrderLocationNameEnum,
      orderPrice?: PackageDealsGetCollectionOrderPriceEnum,
      orderAvailable?: PackageDealsGetCollectionOrderAvailableEnum,
      location?: string,
      location2?: Array<string>,
      type?: string,
      type2?: Array<string>,
      timeslots?: string,
      timeslots2?: Array<string>,
      period?: string,
      period2?: Array<string>,
      translationsName?: string,
      cateringPackage?: boolean,
      includingHallRental?: boolean,
      available?: boolean,
      deleted?: boolean,
      reservation?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PackageDealsGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.packageDealsGetCollection(
          page,
          itemsPerPage,
          orderTranslationsName,
          orderType,
          orderLocationName,
          orderPrice,
          orderAvailable,
          location,
          location2,
          type,
          type2,
          timeslots,
          timeslots2,
          period,
          period2,
          translationsName,
          cateringPackage,
          includingHallRental,
          available,
          deleted,
          reservation,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['PackageDealApi.packageDealsGetCollection']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a PackageDeal resource.
     * @summary Retrieves a PackageDeal resource.
     * @param {string} id PackageDeal identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packageDealsIdGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PackageDealRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.packageDealsIdGet(id, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['PackageDealApi.packageDealsIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Updates the PackageDeal resource.
     * @summary Updates the PackageDeal resource.
     * @param {string} id PackageDeal identifier
     * @param {PackageDealWrite} packageDealWrite The updated PackageDeal resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packageDealsIdPatch(
      id: string,
      packageDealWrite: PackageDealWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PackageDealRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.packageDealsIdPatch(
          id,
          packageDealWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['PackageDealApi.packageDealsIdPatch']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Creates a PackageDealOrder resource.
     * @summary Change the order of the package deal priority
     * @param {PackageDealOrderPackagedealChangeOrder} packageDealOrderPackagedealChangeOrder The new PackageDealOrder resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packageDealschangeOrderPost(
      packageDealOrderPackagedealChangeOrder: PackageDealOrderPackagedealChangeOrder,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.packageDealschangeOrderPost(
          packageDealOrderPackagedealChangeOrder,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['PackageDealApi.packageDealschangeOrderPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * PackageDealApi - factory interface
 * @export
 */
export const PackageDealApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PackageDealApiFp(configuration);
  return {
    /**
     * Retrieves the collection of PackageDeal resources.
     * @summary Get base package deal for given location
     * @param {PackageDealApiLocationsIdpackageDealsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    locationsIdpackageDealsGetCollection(
      requestParameters: PackageDealApiLocationsIdpackageDealsGetCollectionRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<LocationsIdpackageDealsGetCollection200Response> {
      return localVarFp
        .locationsIdpackageDealsGetCollection(
          requestParameters.id,
          requestParameters.startTime,
          requestParameters.endTime,
          requestParameters.date,
          requestParameters.pax,
          requestParameters.email,
          requestParameters.orderTranslationsName,
          requestParameters.orderType,
          requestParameters.orderLocationName,
          requestParameters.orderPrice,
          requestParameters.orderAvailable,
          requestParameters.location,
          requestParameters.location2,
          requestParameters.type,
          requestParameters.type2,
          requestParameters.timeslots,
          requestParameters.timeslots2,
          requestParameters.period,
          requestParameters.period2,
          requestParameters.translationsName,
          requestParameters.cateringPackage,
          requestParameters.includingHallRental,
          requestParameters.available,
          requestParameters.deleted,
          requestParameters.reservation,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of PackageDeal resources.
     * @summary Retrieves the collection of PackageDeal resources.
     * @param {PackageDealApiPackageDealsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealsGetCollection(
      requestParameters: PackageDealApiPackageDealsGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<PackageDealsGetCollection200Response> {
      return localVarFp
        .packageDealsGetCollection(
          requestParameters.page,
          requestParameters.itemsPerPage,
          requestParameters.orderTranslationsName,
          requestParameters.orderType,
          requestParameters.orderLocationName,
          requestParameters.orderPrice,
          requestParameters.orderAvailable,
          requestParameters.location,
          requestParameters.location2,
          requestParameters.type,
          requestParameters.type2,
          requestParameters.timeslots,
          requestParameters.timeslots2,
          requestParameters.period,
          requestParameters.period2,
          requestParameters.translationsName,
          requestParameters.cateringPackage,
          requestParameters.includingHallRental,
          requestParameters.available,
          requestParameters.deleted,
          requestParameters.reservation,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a PackageDeal resource.
     * @summary Retrieves a PackageDeal resource.
     * @param {PackageDealApiPackageDealsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealsIdGet(
      requestParameters: PackageDealApiPackageDealsIdGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<PackageDealRead> {
      return localVarFp
        .packageDealsIdGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the PackageDeal resource.
     * @summary Updates the PackageDeal resource.
     * @param {PackageDealApiPackageDealsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealsIdPatch(
      requestParameters: PackageDealApiPackageDealsIdPatchRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<PackageDealRead> {
      return localVarFp
        .packageDealsIdPatch(
          requestParameters.id,
          requestParameters.packageDealWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a PackageDealOrder resource.
     * @summary Change the order of the package deal priority
     * @param {PackageDealApiPackageDealschangeOrderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packageDealschangeOrderPost(
      requestParameters: PackageDealApiPackageDealschangeOrderPostRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .packageDealschangeOrderPost(
          requestParameters.packageDealOrderPackagedealChangeOrder,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for locationsIdpackageDealsGetCollection operation in PackageDealApi.
 * @export
 * @interface PackageDealApiLocationsIdpackageDealsGetCollectionRequest
 */
export interface PackageDealApiLocationsIdpackageDealsGetCollectionRequest {
  /**
   * Location for retrieving base packagedeal for
   * @type {number}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly id: number;

  /**
   * Start time of hall to determine base packagedeal for
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly startTime: string;

  /**
   * End date of hall to determine base packagedeal for
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly endTime: string;

  /**
   * Date to filter available package deal
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly date: string;

  /**
   * Pax of hall to determine base packagedeal for
   * @type {number}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly pax: number;

  /**
   * E-mail address for the reservation used to determine if the request falls under a contract
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly email?: string;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly orderTranslationsName?: LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly orderType?: LocationsIdpackageDealsGetCollectionOrderTypeEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly orderLocationName?: LocationsIdpackageDealsGetCollectionOrderLocationNameEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly orderPrice?: LocationsIdpackageDealsGetCollectionOrderPriceEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly orderAvailable?: LocationsIdpackageDealsGetCollectionOrderAvailableEnum;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly location?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly location2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly type?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly type2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly timeslots?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly timeslots2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly period?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly period2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly translationsName?: string;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly cateringPackage?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly includingHallRental?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly available?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly deleted?: boolean;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiLocationsIdpackageDealsGetCollection
   */
  readonly reservation?: string;
}

/**
 * Request parameters for packageDealsGetCollection operation in PackageDealApi.
 * @export
 * @interface PackageDealApiPackageDealsGetCollectionRequest
 */
export interface PackageDealApiPackageDealsGetCollectionRequest {
  /**
   * The collection page number
   * @type {number}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly page?: number;

  /**
   * The number of items per page
   * @type {number}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly itemsPerPage?: number;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly orderTranslationsName?: PackageDealsGetCollectionOrderTranslationsNameEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly orderType?: PackageDealsGetCollectionOrderTypeEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly orderLocationName?: PackageDealsGetCollectionOrderLocationNameEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly orderPrice?: PackageDealsGetCollectionOrderPriceEnum;

  /**
   *
   * @type {'asc' | 'desc'}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly orderAvailable?: PackageDealsGetCollectionOrderAvailableEnum;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly location?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly location2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly type?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly type2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly timeslots?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly timeslots2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly period?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly period2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly translationsName?: string;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly cateringPackage?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly includingHallRental?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly available?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly deleted?: boolean;

  /**
   *
   * @type {string}
   * @memberof PackageDealApiPackageDealsGetCollection
   */
  readonly reservation?: string;
}

/**
 * Request parameters for packageDealsIdGet operation in PackageDealApi.
 * @export
 * @interface PackageDealApiPackageDealsIdGetRequest
 */
export interface PackageDealApiPackageDealsIdGetRequest {
  /**
   * PackageDeal identifier
   * @type {string}
   * @memberof PackageDealApiPackageDealsIdGet
   */
  readonly id: string;
}

/**
 * Request parameters for packageDealsIdPatch operation in PackageDealApi.
 * @export
 * @interface PackageDealApiPackageDealsIdPatchRequest
 */
export interface PackageDealApiPackageDealsIdPatchRequest {
  /**
   * PackageDeal identifier
   * @type {string}
   * @memberof PackageDealApiPackageDealsIdPatch
   */
  readonly id: string;

  /**
   * The updated PackageDeal resource
   * @type {PackageDealWrite}
   * @memberof PackageDealApiPackageDealsIdPatch
   */
  readonly packageDealWrite: PackageDealWrite;
}

/**
 * Request parameters for packageDealschangeOrderPost operation in PackageDealApi.
 * @export
 * @interface PackageDealApiPackageDealschangeOrderPostRequest
 */
export interface PackageDealApiPackageDealschangeOrderPostRequest {
  /**
   * The new PackageDealOrder resource
   * @type {PackageDealOrderPackagedealChangeOrder}
   * @memberof PackageDealApiPackageDealschangeOrderPost
   */
  readonly packageDealOrderPackagedealChangeOrder: PackageDealOrderPackagedealChangeOrder;
}

/**
 * PackageDealApi - object-oriented interface
 * @export
 * @class PackageDealApi
 * @extends {BaseAPI}
 */
export class PackageDealApi extends BaseAPI {
  /**
   * Retrieves the collection of PackageDeal resources.
   * @summary Get base package deal for given location
   * @param {PackageDealApiLocationsIdpackageDealsGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PackageDealApi
   */
  public locationsIdpackageDealsGetCollection(
    requestParameters: PackageDealApiLocationsIdpackageDealsGetCollectionRequest,
    options?: AxiosRequestConfig,
  ) {
    return PackageDealApiFp(this.configuration)
      .locationsIdpackageDealsGetCollection(
        requestParameters.id,
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.date,
        requestParameters.pax,
        requestParameters.email,
        requestParameters.orderTranslationsName,
        requestParameters.orderType,
        requestParameters.orderLocationName,
        requestParameters.orderPrice,
        requestParameters.orderAvailable,
        requestParameters.location,
        requestParameters.location2,
        requestParameters.type,
        requestParameters.type2,
        requestParameters.timeslots,
        requestParameters.timeslots2,
        requestParameters.period,
        requestParameters.period2,
        requestParameters.translationsName,
        requestParameters.cateringPackage,
        requestParameters.includingHallRental,
        requestParameters.available,
        requestParameters.deleted,
        requestParameters.reservation,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of PackageDeal resources.
   * @summary Retrieves the collection of PackageDeal resources.
   * @param {PackageDealApiPackageDealsGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PackageDealApi
   */
  public packageDealsGetCollection(
    requestParameters: PackageDealApiPackageDealsGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return PackageDealApiFp(this.configuration)
      .packageDealsGetCollection(
        requestParameters.page,
        requestParameters.itemsPerPage,
        requestParameters.orderTranslationsName,
        requestParameters.orderType,
        requestParameters.orderLocationName,
        requestParameters.orderPrice,
        requestParameters.orderAvailable,
        requestParameters.location,
        requestParameters.location2,
        requestParameters.type,
        requestParameters.type2,
        requestParameters.timeslots,
        requestParameters.timeslots2,
        requestParameters.period,
        requestParameters.period2,
        requestParameters.translationsName,
        requestParameters.cateringPackage,
        requestParameters.includingHallRental,
        requestParameters.available,
        requestParameters.deleted,
        requestParameters.reservation,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a PackageDeal resource.
   * @summary Retrieves a PackageDeal resource.
   * @param {PackageDealApiPackageDealsIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PackageDealApi
   */
  public packageDealsIdGet(
    requestParameters: PackageDealApiPackageDealsIdGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return PackageDealApiFp(this.configuration)
      .packageDealsIdGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the PackageDeal resource.
   * @summary Updates the PackageDeal resource.
   * @param {PackageDealApiPackageDealsIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PackageDealApi
   */
  public packageDealsIdPatch(
    requestParameters: PackageDealApiPackageDealsIdPatchRequest,
    options?: AxiosRequestConfig,
  ) {
    return PackageDealApiFp(this.configuration)
      .packageDealsIdPatch(
        requestParameters.id,
        requestParameters.packageDealWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates a PackageDealOrder resource.
   * @summary Change the order of the package deal priority
   * @param {PackageDealApiPackageDealschangeOrderPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PackageDealApi
   */
  public packageDealschangeOrderPost(
    requestParameters: PackageDealApiPackageDealschangeOrderPostRequest,
    options?: AxiosRequestConfig,
  ) {
    return PackageDealApiFp(this.configuration)
      .packageDealschangeOrderPost(
        requestParameters.packageDealOrderPackagedealChangeOrder,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum =
  (typeof LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum)[keyof typeof LocationsIdpackageDealsGetCollectionOrderTranslationsNameEnum];
/**
 * @export
 */
export const LocationsIdpackageDealsGetCollectionOrderTypeEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationsIdpackageDealsGetCollectionOrderTypeEnum =
  (typeof LocationsIdpackageDealsGetCollectionOrderTypeEnum)[keyof typeof LocationsIdpackageDealsGetCollectionOrderTypeEnum];
/**
 * @export
 */
export const LocationsIdpackageDealsGetCollectionOrderLocationNameEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationsIdpackageDealsGetCollectionOrderLocationNameEnum =
  (typeof LocationsIdpackageDealsGetCollectionOrderLocationNameEnum)[keyof typeof LocationsIdpackageDealsGetCollectionOrderLocationNameEnum];
/**
 * @export
 */
export const LocationsIdpackageDealsGetCollectionOrderPriceEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationsIdpackageDealsGetCollectionOrderPriceEnum =
  (typeof LocationsIdpackageDealsGetCollectionOrderPriceEnum)[keyof typeof LocationsIdpackageDealsGetCollectionOrderPriceEnum];
/**
 * @export
 */
export const LocationsIdpackageDealsGetCollectionOrderAvailableEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type LocationsIdpackageDealsGetCollectionOrderAvailableEnum =
  (typeof LocationsIdpackageDealsGetCollectionOrderAvailableEnum)[keyof typeof LocationsIdpackageDealsGetCollectionOrderAvailableEnum];
/**
 * @export
 */
export const PackageDealsGetCollectionOrderTranslationsNameEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type PackageDealsGetCollectionOrderTranslationsNameEnum =
  (typeof PackageDealsGetCollectionOrderTranslationsNameEnum)[keyof typeof PackageDealsGetCollectionOrderTranslationsNameEnum];
/**
 * @export
 */
export const PackageDealsGetCollectionOrderTypeEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type PackageDealsGetCollectionOrderTypeEnum =
  (typeof PackageDealsGetCollectionOrderTypeEnum)[keyof typeof PackageDealsGetCollectionOrderTypeEnum];
/**
 * @export
 */
export const PackageDealsGetCollectionOrderLocationNameEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type PackageDealsGetCollectionOrderLocationNameEnum =
  (typeof PackageDealsGetCollectionOrderLocationNameEnum)[keyof typeof PackageDealsGetCollectionOrderLocationNameEnum];
/**
 * @export
 */
export const PackageDealsGetCollectionOrderPriceEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type PackageDealsGetCollectionOrderPriceEnum =
  (typeof PackageDealsGetCollectionOrderPriceEnum)[keyof typeof PackageDealsGetCollectionOrderPriceEnum];
/**
 * @export
 */
export const PackageDealsGetCollectionOrderAvailableEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type PackageDealsGetCollectionOrderAvailableEnum =
  (typeof PackageDealsGetCollectionOrderAvailableEnum)[keyof typeof PackageDealsGetCollectionOrderAvailableEnum];
